type Action = 'click';
type Target = 'chat-opener' | 'eligibility-list-opener' | 'exempt-list-opener';

export default function useListener(action: Action, target: Target, cb: () => void) {
  onMounted(() => {
    const opener = document.querySelector(`[data-${target}]`);
    opener?.addEventListener(action, cb);
  });
}